<script setup lang="ts">
import dayjs from 'dayjs'
import zhcn from 'dayjs/locale/zh-cn'
import { showConfirmDialog } from 'vant'
import { getBuyerList } from '@/api/modules/home'

definePage({
  name: 'sell-off',
  meta: {
    title: '砸盘榜',
  },
})

const list = ref([]) as any
const loading = ref(false)
const finished = ref(false)
const date = dayjs().locale(zhcn).format('YYYY/MM/DD HH:MM:ss')

async function onLoad() {
  try {
    const { status, data } = await getBuyerList({
      page: 1,
    })
    if (status === 1) {
      list.value = data.list
      finished.value = data.finished
    }
  }
  catch (error) {
    console.error(error)
  }
  finally {
    loading.value = false
  }
}

function showTip() {
  showConfirmDialog({
    title: '扫货/砸盘说明',
    showCancelButton: false,
    confirmButtonText: '我知道了',
    messageAlign: 'left',
    message:
    '扫货：以卖方的价格买入，且买单量大于卖方的总量，由此推升了买卖盘口的价格。\n砸盘：以买方的价格卖出，且卖单量大于买方的总量，由此压低了买卖盘口的价格',
  })
    .then(() => {
    // on confirm
    })
}
</script>

<template>
  <FmPageLayout navbar back class="fluctuation-page">
    <template #navbar-end>
      <FmIcon name="material-symbols:help-outline-rounded" class="text-22px color-[#fff]" @click="showTip" />
    </template>
    <van-list
      v-model:loading="loading"
      :finished="finished"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <div class="flex justify-between bg-[#FFEFE5] px-8px py-9px text-12px color-[#3C78FF]">
        <div>
          当前数据为延时数据，全盘行情用户可查看实
        </div>
        <FmIcon name="tdesign:chevron-right-s" class="text-16px" />
      </div>
      <div class="bg-[#fff]">
        <div class="m-l-8px m-r-8px flex items-center justify-between">
          <div class="flex items-center justify-between gap-10px p-b-8px p-t-8px text-14px color-[#333333]">
            统计数据为全盘行情数据
          </div>
          <div class="flex items-center text-12px color-[#999]">
            <span>更新：{{ date }}</span>
          </div>
        </div>
        <vxe-table
          header-row-class-name="table-header"
          :data="list"
        >
          <vxe-column field="name" title="名称" fixed="left" width="30%">
            <template #default="{ row }">
              <div class="text-15px font-500">
                {{ row.name }}
              </div>
              <div class="text-13px">
                {{ row.code }}
              </div>
            </template>
          </vxe-column>
          <vxe-column width="26%" field="data" title="股数" sortable />
          <vxe-column width="24%" field="price" title="金额" sortable>
            <template #default="{ row }">
              <div class="text-15px font-500">
                {{ row.price }}万
              </div>
            </template>
          </vxe-column>
          <vxe-column width="19%" field="num" title="均价" sortable />
          <vxe-column field="price" title="现价" width="24%" sortable>
            <template #default="{ row }">
              <div class="text-15px font-500" :style="{ color: '#E51A2D' }">
                {{ row.price }}
              </div>
            </template>
          </vxe-column>
          <vxe-column field="per" title="涨跌幅" width="24%" sortable>
            <template #default="{ row }">
              <div class="text-15px font-500" :style="{ color: '#E51A2D' }">
                {{ row.per }}
              </div>
            </template>
          </vxe-column>
          <vxe-column width="22%" field="count" title="次数" sortable align="right" />
        </vxe-table>
      </div>
    </van-list>
  </FmPageLayout>
</template>

<style lang="scss" scoped>
.fluctuation-page {
  :deep(.van-tabs__nav) {
    background-color: #f1f2f7;
  }

  :deep(.van-tab--active) {
    font-size: 17px;
  }

  .tab-conten {
    position: fixed;
    left: 0;
    z-index: 2;
    width: 100%;
  }

  .active-card {
    color: #fff;
    background-color: #3c78ff;
    border-color: #3c78ff !important;
  }
}
</style>
